"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventName;
(function (EventName) {
    EventName["clickSuggestion"] = "click-suggestion";
    EventName["clickItem"] = "click-item";
    EventName["redirect"] = "redirect";
    EventName["purchase"] = "purchase";
    EventName["addToCart"] = "add-to-cart";
    EventName["updateCart"] = "update-cart";
    EventName["viewPage"] = "view-page";
})(EventName = exports.EventName || (exports.EventName = {}));
;
;
//# sourceMappingURL=types.js.map